/**
 * DetailPanel Component
 * Right panel container that renders CampaignDetailView or OverviewView
 */

import React from 'react';
import { useCommandCenter } from '../../contexts/CommandCenterContext';
import CampaignDetailView from './CampaignDetailView';
import OverviewView from './OverviewView';

const DetailPanel = ({ onAction }) => {
    const { selectedCampaign, isLoading } = useCommandCenter();

    if (isLoading) {
        return (
            <div style={{
                flex: 1,
                padding: 'var(--space-6)',
                background: 'var(--color-background)',
                overflow: 'auto'
            }}>
                <div style={{
                    height: '100px',
                    background: 'var(--color-surface)',
                    borderRadius: 'var(--radius-lg)',
                    marginBottom: 'var(--space-4)',
                    animation: 'pulse 2s infinite'
                }} />
                <div style={{
                    height: '200px',
                    background: 'var(--color-surface)',
                    borderRadius: 'var(--radius-lg)',
                    marginBottom: 'var(--space-4)',
                    animation: 'pulse 2s infinite'
                }} />
                <div style={{
                    height: '150px',
                    background: 'var(--color-surface)',
                    borderRadius: 'var(--radius-lg)',
                    animation: 'pulse 2s infinite'
                }} />
            </div>
        );
    }

    return (
        <div style={{
            flex: 1,
            overflow: 'auto',
            background: 'var(--color-background)'
        }}>
            {selectedCampaign ? (
                <CampaignDetailView
                    campaign={selectedCampaign}
                    onAction={onAction}
                />
            ) : (
                <OverviewView />
            )}
        </div>
    );
};

export default DetailPanel;
